import {LinkGroup} from 'shared/pretty-easy-navigation/models';
import {LearnerAppLink, LegalMentionsLink} from '../links';
import {NavigationContext} from '../navigation.context';
import {SiteMapLink} from "../links/site-map.link";

export const LearnerFooterGroup = (context: NavigationContext): LinkGroup => ({
    type: 'linkGroup',
    links: [
        LearnerAppLink(context),
        LegalMentionsLink(context),
        SiteMapLink(context, 'learner')
    ]
});